import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const BONUSES = [{
  num: '#1',
  title: 'Protocolo de Psicoeducación sobre el Sueño',
  intro: 'Documento descargable listo para trabajar en sesión o entregar al paciente.',
  footer: 'Para que el paciente pueda comprender su problema sin lenguaje técnico complejo y participe mejor del proceso terapéutico.'
}, {
  num: '#2',
  title: 'Diario de Sueño del Paciente',
  intro: 'Planilla descargable y editable para entregar desde la primera sesión.',
  footer: 'Para monitorear el patrón de sueño sin que el paciente tenga que completar registros largos o difíciles.'
}, {
  num: '#3',
  title: 'Guía de Higiene del Sueño',
  intro: 'Documento descargable listo para entregar al paciente.',
  footer: 'Para que el paciente tenga una guía simple, clara y aplicable desde el primer día.'
}];
export const BonusSection: React.FC = () => {
  return <section className="py-16 bg-offwhite px-4 sm:px-6 lg:px-8" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <div className="text-center mb-12" data-id="element-14">
          <p className="text-accent font-bold tracking-wider uppercase mb-2" data-id="element-15">
            Oferta Especial
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-navy mb-4" data-id="element-16">
            BONUS PROFESIONALES
          </h2>
          <p className="text-2xl text-navy font-semibold" data-id="element-17">
            GRATIS POR EL DÍA DE HOY
          </p>
        </div>

        <div className="space-y-6" data-id="element-18">
          {BONUSES.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl shadow-md border-2 border-accent overflow-hidden relative" data-id="element-19">
              <div className="absolute top-4 right-4 bg-accent text-white text-xs sm:text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-20">
                ¡Gratis Hoy!
              </div>
              <div className="p-6 sm:p-8" data-id="element-21">
                <div className="flex items-center gap-4 mb-4" data-id="element-22">
                  <div className="w-12 h-12 bg-lavender rounded-full flex items-center justify-center shrink-0" data-id="element-23">
                    <Gift className="w-6 h-6 text-accent" data-id="element-24" />
                  </div>
                  <div className="pr-20" data-id="element-25">
                    <p className="text-accent font-bold uppercase text-sm" data-id="element-26">
                      BONUS {bonus.num}
                    </p>
                    <h3 className="font-serif text-xl sm:text-2xl font-bold text-navy" data-id="element-27">
                      {bonus.title}
                    </h3>
                  </div>
                </div>
                <p className="text-gray-700 font-medium" data-id="element-28">{bonus.intro}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};